import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';

export default () => {
    return (
        <Grid container spacing={4} className="page" justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={6} lg={4}>
                <h1>404</h1>
                <br />
                <p>We could not find this page :(</p>
                <br />
                <Link to="/">
                    <Button variant="contained" fullWidth>
                        Head back home
                    </Button>
                </Link>
            </Grid>
        </Grid>
    );
};
